import { normalizeSniSn } from './sni-session.js'

export function extractSniFromQrText (text) {
  const value = String(text || '').trim()
  if (!value) return ''
  if (/^[a-z][a-z\d+.-]*:\/\//i.test(value)) {
    try {
      const url = new URL(value)
      return normalizeSniSn(url.searchParams.get('sn'))
    } catch (error) {
      return ''
    }
  }
  return normalizeSniSn(value)
}

export function resolveDeviceAction (session, sn) {
  const normalizedSn = normalizeSniSn(sn)
  const devices = Array.isArray(session && session.deviceList) ? session.deviceList : []
  return devices.some(device => normalizeSniSn(device && device.sn) === normalizedSn)
    ? 'switch'
    : 'bind'
}
